import { Ws } from './ws'

/** 订阅或取消订阅时 计算话题列表增量 */
const getTopicList = (pre, delta, isDelete) => {
  const newTopicList = [...pre]
  const deltaTopicList = [...delta]
  // 取消订阅
  if (isDelete) {
    return {
      newTopicList: newTopicList.filter(
        (n) => !deltaTopicList.some((d) => d.topicKey === n.topicKey),
      ),
      deltaTopicList,
    }
  }
  // 订阅
  deltaTopicList.forEach((d) => {
    if (newTopicList.some((n) => n.topicKey === d.topicKey)) {
      d.used = true
    } else {
      newTopicList.push(d)
    }
  })
  return {
    newTopicList,
    deltaTopicList: deltaTopicList.filter((d) => !d.used),
  }
}

const RequestType = {
  /** 订阅话题 */
  subscribe: 0,
  /** 取消订阅话题 */
  cancelSub: 1,
  /** 推送消息到话题列表 */
  publish: 2,
}

class Socket {
  constructor(url) {
    this.openStatus = false
    this.ws = new Ws({
      url,
      socketReceiveMsg: this.socketReceiveMsg.bind(this),
      onOpen: this.handleReOpen.bind(this),
      onClose: this.onClose.bind(this)
    })
    this.value = {
      data: {},
      open: () => this.ws?.reconnect(),
      close: () => this.ws?.close(),
      subscribe: () => {},
      cancelSub: () => {},
      publish: () => {},
    }
    this.onMessageFnMap = {} // 订阅时传入回调表
    this.topicList = [] // 断线前的订阅列表
    this.roomMap = {}
  }

  init() {
    this.ws.init()
    return this
  }

  unmount() {
    this.ws.unmount()
  }

  onClose() {
    this.openStatus = false
  }

  /** 处理收到消息 */
  socketReceiveMsg(event) {
    try {
      if (event.data === 'pong') return
      const data = JSON.parse(event.data || '{}')
      const { topicKey, content, messageType } = data
      /** 订阅时传入回调处理 */
      this.onMessageFnMap[topicKey]?.forEach((onMessage) => onMessage?.(content, messageType))
      this.value.data = {
        ...this.value.data,
        [topicKey]: content,
      }
      if (!this.openStatus) {
        this.openStatus = true
      }
    } catch (e) {
      console.error(e)
    }
  }

  /** 订阅话题 */
  subscribe(topicKeyList, onMessage, forceSub,) { // 是否强制订阅 (忽略对重复订阅的过滤)
    this._sendMsg(RequestType.subscribe, { topicKeyList })
    topicKeyList.forEach(({ topicKey }) => {
      if (!this.onMessageFnMap[topicKey]) this.onMessageFnMap[topicKey] = []
      this.onMessageFnMap[topicKey].push(onMessage)
    })
    const { newTopicList, deltaTopicList } = getTopicList(
      this.topicList,
      topicKeyList,
    )
    if (deltaTopicList.length || forceSub) this.topicList = newTopicList
  }

  /** 取消订阅话题 */
  cancelSub(topicKeyList) {
    const { newTopicList, deltaTopicList } = getTopicList(
      this.topicList,
      topicKeyList,
      true,
    )
    if (!deltaTopicList.length) return // 过滤重复操作
    this._sendMsg(RequestType.cancelSub, { topicKeyList })
    this.topicList = newTopicList
    const tempRoomMap = { ...this.roomMap }
    deltaTopicList
      .filter((d) => d.room)
      .forEach((topicKeyDto) => {
        delete tempRoomMap[topicKeyDto.topicKey]
      })
    this.roomMap = tempRoomMap
    deltaTopicList.forEach(({ topicKey }) => {
      delete this.onMessageFnMap[topicKey]
    })
  }

  /** 推送消息到话题列表 */
  publish(
    topicKeyList,
    messageContent,
  ) {
    this._sendMsg(RequestType.publish, { topicKeyList, messageContent })
  }

  /** 发送消息 */
  _sendMsg(requestType, baseContent) {
    const sendData = { requestType, baseContent }
    this.ws?.send(JSON.stringify(sendData))
  }

  /** 重新连接ws 重新订阅话题 获取用户列表 */
  handleReOpen() {
    this._getWSInstance()
    this.topicList.length && this.subscribe(this.topicList, () => {}, true)
    this.openStatus = true
  }

  clear() {
    this.roomMap = {}
    this.topicList = []
    this.value = {
      ...this.value,
      data: {}
    }
  }

  /** 获取实例 */
  _getWSInstance() {
    const wsInstance = this.ws
    this.value = {
      ...this.value,
      open: () => wsInstance?.reconnect(),
      close: (logout) => {
        wsInstance?.close()
        logout && this.clear()
      },
      subscribe: this.subscribe,
      cancelSub: this.cancelSub,
      publish: this.publish,
    }
  }
}

export default Socket
